import React from 'react';
import {Button, TextField} from '@betareader/design-system';
import {push} from '../../../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import MultipleChoiceOptions from './multipleChoiceOptions';
import LinearScaleOptions from './linearScaleOptions';
import CheckboxOptions from './checkboxOptions';
import useAutoSaveContext from '../../../../hooks/useAutoSaveContext';
import './question.css';

const questionTypeOptions = [
  {value: 'LONG_TEXT', text: 'Text'},
  {value: 'MULTIPLE_CHOICE', text: 'Multiple choice'},
  {value: 'CHECKBOX', text: 'Checkbox'},
  {value: 'LINEAR_SCALE', text: 'Linear scale'}
];

export const Question = ({index, question, deleteQuestion, updateQuestion, t}) => {
  const {save} = useAutoSaveContext();
  const kind = question.kind || 'LONG_TEXT';
  const saveShortcut = event => {
    if ((event.key === 's' || event.key === 'S') && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      save();
    }
  };
  const handleOptionsChanged = options => updateQuestion({options, index});

  return <section className="br-survey-question question-box" aria-label={t('Question')}>
    <div className="br-survey-question__header">
      <TextField label={t('Question')} id={`survey-question-${index}`}
        value={question.question || ''} onKeyDown={saveShortcut}
        onChange={event => updateQuestion({question: event.target.value, index})} />
      <label className="br-survey-question__kind">
        <span>{t('Type')}</span>
        <select value={kind} onChange={event => updateQuestion({
          kind: event.target.value, options: undefined, index
        })}>
          {questionTypeOptions.map(option => <option key={option.value} value={option.value}>
            {t(option.text)}
          </option>)}
        </select>
      </label>
    </div>
    <TextField label={t('Description')} id={`survey-description-${index}`}
      value={question.description || ''} onKeyDown={saveShortcut}
      onChange={event => updateQuestion({description: event.target.value, index})} />
    {kind === 'LONG_TEXT' && <input className="br-survey-question__answer"
      aria-label={t('Answer')} value={t('Answer')} disabled readOnly />}
    {kind === 'MULTIPLE_CHOICE' && <MultipleChoiceOptions
      onOptionsChanged={handleOptionsChanged} options={question.options || {}}
      questionId={question._id || index} />}
    {kind === 'LINEAR_SCALE' && <LinearScaleOptions
      onOptionsChanged={handleOptionsChanged} options={question.options || {}}
      questionId={question._id || index} />}
    {kind === 'CHECKBOX' && <CheckboxOptions
      onOptionsChanged={handleOptionsChanged} options={question.options || {}}
      questionId={question._id || index} />}
    <div className="br-survey-question__footer">
      <Button variant="ghost" onClick={deleteQuestion}>
        {t('Remove')} {t('Question')}
      </Button>
    </div>
  </section>;
};

const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Question));
